import React from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';

function shouldShowPagination(props) {
    return !!props.pagination && (props.serverPagination || props.rows.length > props.pageSize);
}

function shouldShowServerPagination(props) {
    return shouldShowPagination(props) && props.serverPagination;
}

function getNumberOfPages(props) {
    if (props.pages) return props.pages;
    if (shouldShowServerPagination(props)) return Number.POSITIVE_INFINITY;
    if (!props.rows || !props.rows.length) return undefined;
    return Math.ceil(props.rows.length / props.pageSize);
}

const withPagination = (Component) => {
    const PaginationWrapper = (props) => {
        const paginationProps = ({
            showPagination: shouldShowPagination(props),
            manual: shouldShowServerPagination(props),
            pages: getNumberOfPages(props),
            page: props.page,
            onPageChange: shouldShowServerPagination(props) ? (page) => props.changePage(page + 1) : fp.noop,
            ofText: shouldShowServerPagination(props) ? '' : `of ${getNumberOfPages(props)}`,
            pageSize: shouldShowPagination(props) ? props.pageSize : props.rows.length,
            defaultPageSize: shouldShowPagination(props) ? props.pageSize : props.rows.length,
            pageSizeOptions: [props.pageSize]
        });

        return (
            <Component
                { ...props }
                paginationProps={ paginationProps }
            />
        );
    };

    PaginationWrapper.propTypes = {
        changePage: PropTypes.func,
        rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        page: PropTypes.number,
        pages: PropTypes.number,
        pageSize: PropTypes.number,
        pagination: PropTypes.bool,
        serverPagination: PropTypes.bool
    };

    PaginationWrapper.defaultProps = {
        changePage: fp.noop,
        page: undefined,
        pages: null,
        pageSize: 50,
        pagination: false,
        serverPagination: false
    };

    return PaginationWrapper;
};
export default withPagination;
